import type { EnvironmentData } from '@cld/unicorn-api';
import { useEffect } from 'react';
import type { State } from '../state';
import type { ConsoleLogger, LocationApi } from '../types';

export const useRedirectToNewNavigation = ({
  state,
  locationApi,
  environmentData,
  consoleLogger,
}: {
  state: State;
  locationApi: LocationApi;
  environmentData: EnvironmentData;
  consoleLogger: ConsoleLogger;
}) => {
  const eligibleForNewNavigation = state.applicationStatus === 'ready' ? state.account.eligibleForNewNavigation : undefined;
  const pathname = new URL(locationApi.getHref()).pathname;

  useEffect(() => {
    if (eligibleForNewNavigation === true && !pathname.startsWith('/console')) {
      locationApi.redirect(`${environmentData.origin}/app?originUrl=${encodeURIComponent(locationApi.getHref())}`, { replace: true });

      consoleLogger.debug(
        'general',
        `This account is eligible for new navigation - redirecting to ${environmentData.origin}/app?originUrl=${locationApi.getHref()}`
      );
    }
  }, [eligibleForNewNavigation, locationApi, environmentData, consoleLogger, pathname]);
};
